import { Box, Header, Text, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { primitive } from 'styles/constants/primitives';

export const Inner = Box.withConfig({
  flexDirection: 'column',
  alignItems: 'center',
  marginY: '0',
  marginX: 'auto',
  width: { base: 'full', md: '70%' },
});

export const Title = Header.withConfig({
  marginTop: '$4',
  variant: 'headerOne',
  color: primitive.bk.$bbqBrown,
});

export const Content = Text.withConfig({
  color: primitive.bk.$bbqBrown,
  variant: 'copyOne',
  fontSize: 'md',
  lineHeight: 'md',
  paddingX: '$8',
  paddingY: '$4',
  textAlign: 'center',
});

export const StyledActionButton = makeUclComponent(ActionButton).withConfig({
  width: 'full',
  padding: '$4',
  _text: {
    fontSize: 'lg',
  },
});

export const StyledDismissButton = makeUclComponent(ActionButton).withConfig({
  marginTop: '$4',
  padding: '$4',
  width: 'full',
  _text: {
    color: primitive.bk.$fieryRed,
    fontSize: 'lg',
  },
  variant: ActionButtonVariants.TEXT_ONLY,
});
